import { cn } from "@oneleet/utils";

export const CircleOneleet = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
    >
      <rect width="24" height="24" rx="12" fill="#E64228" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8 18.8H13.4L13.4 5.39999H17.3619V15.6268H19.8V18.8Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.2 5.40002H10.6V18.8H6.63809V8.57321H4.2V5.40002Z"
        fill="white"
      />
    </svg>
  );
};
